import Vue from "vue";

import {
  ActionSheet,
  Button,
  Calendar,
  Cell,
  Checkbox,
  CheckboxGroup,
  DatetimePicker,
  Dialog,
  Field,
  Form,
  Icon,
  List,
  NavBar,
  Notify,
  Overlay,
  Popover,
  Popup,
  PullRefresh,
  Radio,
  RadioGroup,
  Search,
  Switch,
  Tab,
  Tabbar,
  TabbarItem,
  Tabs,
  Toast,
  Uploader,
  Collapse,
  CollapseItem,
  Loading,
  Sticky,
  Grid,
  GridItem,
  Badge,
  Sidebar,
  Swipe,
  SwipeItem,
  SidebarItem,
  DropdownMenu,
  DropdownItem,
  Lazyload,
  Picker,
  NoticeBar,
  Image as VanImage
} from "vant";

Vue.use(ActionSheet)
  .use(Button)
  .use(Tabbar)
  .use(TabbarItem)
  .use(NavBar)
  .use(Icon)
  .use(Tab)
  .use(Tabs)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(List)
  .use(Cell)
  .use(PullRefresh)
  .use(Uploader)
  .use(Toast)
  .use(Dialog)
  .use(Notify)
  .use(Search)
  .use(Popover)
  .use(Overlay)
  .use(Form)
  .use(Field)
  .use(DatetimePicker)
  .use(RadioGroup)
  .use(Radio)
  .use(Calendar)
  .use(Switch)
  .use(Collapse)
  .use(CollapseItem)
  .use(Loading)
  .use(Sticky)
  .use(Grid)
  .use(GridItem)
  .use(Badge)
  .use(Sidebar)
  .use(SidebarItem)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Lazyload)
  .use(VanImage)
  .use(Picker)
  .use(Swipe)
  .use(SwipeItem)
  .use(NoticeBar)
